'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _matchPath = require('./matchPath');

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var computeMatch = function computeMatch(router, _ref) {
  var computedMatch = _ref.computedMatch,
      path = _ref.path,
      exact = _ref.exact,
      strict = _ref.strict;
  return computedMatch || (0, _matchPath2.default)(router.location.pathname, path, { exact: exact, strict: strict });
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    _classCallCheck(this, Route);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: this.router
    };
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var parentRouter = this.context.router;

    this.router = _extends({}, parentRouter, {
      match: computeMatch(parentRouter, this.props)
    });

    // Start listening here so we can <Redirect> on the initial render.
    this.unlisten = parentRouter.listen(function () {
      _extends(_this2.router, parentRouter, {
        match: computeMatch(parentRouter, _this2.props)
      });

      _this2.forceUpdate();
    });
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    _extends(this.router, {
      match: computeMatch(this.router, nextProps)
    });
  };

  Route.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Route.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;

    var props = _extends({}, this.router);

    return component ? // component prop gets first priority, only called if there's a match
    props.match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    props.match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
    _react2.default.Children.only(children) : null : null;
  };

  return Route;
}(_react2.default.Component);

Route.contextTypes = {
  router: _react.PropTypes.shape({
    listen: _react.PropTypes.func.isRequired
  }).isRequired
};
Route.propTypes = {
  computedMatch: _react.PropTypes.object, // private, from <Switch>
  path: _react.PropTypes.string,
  exact: _react.PropTypes.bool,
  strict: _react.PropTypes.bool,
  component: _react.PropTypes.func,
  render: _react.PropTypes.func,
  children: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.node])
};
Route.childContextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = Route;


//////////////////
// WEBPACK FOOTER
// ./~/react-router/Route.js
// module id = 607
// module chunks = 0